import { Flex, ListItem } from '@chakra-ui/react';
import { Link } from 'components/shared/Link';
import React from 'react';
import { StyledList } from './StyledList';
import { Title } from './Title';

export const TermsAndConditions = React.memo(() => {
  return (
    <Flex id="條款及細則" flexDirection="column">
      <Title>條款及細則</Title>
      <StyledList>
        <ListItem>此推廣期為2021年10月15日至11月30日。</ListItem>
        <ListItem>此推廣只適用於本港之鴻福堂分店。</ListItem>
        <ListItem>
          會員必須保留已預購家電之完整收據（登記送貨用途及登記保養之用），如有遺失或損毀，將不獲補發。
        </ListItem>
        <ListItem>入會儲值或增值不適用於以上推廣。</ListItem>
        <ListItem>以上推廣於會員感謝日可再享額外95折。</ListItem>
        <ListItem>
          德國寶人氣家電預購e券(1日期) 需於即日內使用，翌日無效及不獲補發。
        </ListItem>
        <ListItem>每張預購e券只可使用1次及預購指定家電1件。</ListItem>
        <ListItem>
          必需使用會員卡內儲值額預購產品，不可以現金、八達通或信用卡支付。
        </ListItem>
        <ListItem>
          以上預購優惠不可兌換現金，不可與任何折扣優惠券、現金券、鴻福堂禮券及其他優惠同時使用。
        </ListItem>
        <ListItem>預購指定家電只適用於免費送貨服務。</ListItem>
        <ListItem>圖片只供參考，實際內容請參照實物。</ListItem>
        <ListItem>推廣內容如有任何更改，恕不另行通知。</ListItem>
        <ListItem>德國寶產品款式如有變更，恕不另行通知。</ListItem>
        <ListItem>
          德國寶產品規格及設計如有變更，恕不另行通知。最新版本以{' '}
          <Link href="https://www.germanpool.com" target="_blank">
            www.germanpool.com
          </Link>{' '}
          德國寶網上版為準。
        </ListItem>
        <ListItem>
          如有任何爭議，一概以「
          <strong>
            QUALITY OF LIFE PRODUCTS COMPANY LIMITED 生活良方產品有限公司
          </strong>
          」的最終決定為準。
        </ListItem>
      </StyledList>
    </Flex>
  );
});
